module.exports = __webpack_public_path__ + "static/media/fuel-alcohol-content.260d066b.svg";